<template>
  <div class="ai-recommend-page app-page">
    <!-- 1. AI匹配分析加载状态 -->
    <div v-if="loading" class="fullpage-loading">
      <div class="loading-wrapper">
        <div class="loading-heart">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
        </div>
        <p class="loading-text">正在进行AI匹配分析，请稍候...</p>
      </div>
    </div>

    <!-- AI匹配进度下滑框 -->
    <el-drawer
      v-if="loading"
      title="AI匹配进行中"
      :visible="loading"
      direction="top"
      size="30%"
      :closable="false"
      :mask="false"
    >
      <div class="matching-progress">
        <div class="progress-steps">
          <div class="step" :class="{ active: currentStep >= 1 }">
            <div class="step-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div class="step-text">获取命理信息</div>
          </div>
          <div class="step-separator" :class="{ active: currentStep >= 2 }"></div>
          <div class="step" :class="{ active: currentStep >= 2 }">
            <div class="step-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
            </div>
            <div class="step-text">分析星座匹配</div>
          </div>
          <div class="step-separator" :class="{ active: currentStep >= 3 }"></div>
          <div class="step" :class="{ active: currentStep >= 3 }">
            <div class="step-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            </div>
            <div class="step-text">筛选最佳匹配</div>
          </div>
        </div>

        <div class="matching-message">
          <p class="main-message">AI 正在为你寻找最契合的灵魂...</p>
          <p class="sub-message">{{ matchingSubMessage }}</p>
        </div>
      </div>
    </el-drawer>

    <!-- 2. 匹配请求加载状态 -->
    <div v-if="isProcessing" class="processing-modal">
      <div class="modal-backdrop"></div>
      <div class="modal-content">
        <div class="processing-heart">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
        </div>
        <p class="processing-text">正在发起匹配请求...</p>
      </div>
    </div>

    <!-- 主卡片 -->
    <div class="ai-content">
      <div v-if="errorMsg" class="error-message">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        {{ errorMsg }}
        <button @click="fetchAiRecommend" class="retry-btn">重新加载</button>
      </div>

      <!-- 匹配结果展示 -->
      <div v-if="aiMatchData && !loading && !errorMsg" class="result-container">
        <div class="result-header">
          <div class="result-header-left">
            <div class="result-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a4 4 0 014 4c0 2-1 3-2 4l-2 8-2-8c-1-1-2-2-2-4a4 4 0 014-4z"/><path d="M8 9h8"/><path d="M9 13h6"/></svg>
            </div>
            <div>
              <div class="result-header-title">AI好友推荐</div>
              <div class="result-header-desc">根据个人资料的生日获取八字与星座最匹配的好友</div>
            </div>
          </div>
        </div>
        <!-- 匹配度概览 -->
        <div class="result-section score-section">
          <div class="section-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            匹配度概览
          </div>
          <div class="score-display">
            <div class="score-ring">
              <svg width="140" height="140" viewBox="0 0 140 140">
                <circle cx="70" cy="70" r="60" fill="none" stroke="#EDEDF0" stroke-width="8"/>
                <circle cx="70" cy="70" r="60" fill="none" stroke="currentColor" stroke-width="8"
                  :stroke-dasharray="377"
                  :stroke-dashoffset="377 - (377 * (aiMatchData.matchScore || 0) / 100)"
                  class="score-arc"
                  stroke-linecap="round"
                  transform="rotate(-90, 70, 70)"
                />
                <text x="70" y="66" text-anchor="middle" class="score-number" fill="currentColor" font-size="32" font-weight="700">{{ aiMatchData.matchScore }}%</text>
                <text x="70" y="88" text-anchor="middle" class="score-label-text" fill="#636E72" font-size="12">匹配度</text>
              </svg>
            </div>
            <div class="score-level" :class="getScoreColorClass(aiMatchData.matchScore)">
              <span v-if="aiMatchData.matchScore >= 80">天作之合</span>
              <span v-else-if="aiMatchData.matchScore >= 60">颇有缘分</span>
              <span v-else>仍需磨合</span>
            </div>
          </div>
        </div>

        <!-- 双方命理分析 -->
        <div class="result-section">
          <div class="section-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
            命理与星座分析
          </div>
          <div class="analysis-grid">
            <div class="analysis-card analysis-you">
              <div class="analysis-header">
                <span class="analysis-badge you-badge">你</span>
                <h4>你的命理特质</h4>
              </div>
              <p class="analysis-text">{{ aiMatchData.userFortuneAnalysis }}</p>
              <p class="constellation-text">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
                星座：{{ aiMatchData.userConstellation }}
              </p>
            </div>
            <div class="analysis-card analysis-them">
              <div class="analysis-header">
                <span class="analysis-badge them-badge">TA</span>
                <h4>对方的命理特质</h4>
              </div>
              <p class="analysis-text">{{ aiMatchData.matchUserFortuneAnalysis }}</p>
              <p class="constellation-text">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
                星座：{{ aiMatchData.targetConstellation }}
              </p>
            </div>
          </div>
        </div>

        <!-- 最佳匹配对象 -->
        <div class="result-section">
          <div class="section-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
            最佳匹配对象
          </div>
          <div class="matched-user-card">
            <div class="matched-user-bg"></div>
            <div class="matched-user-content">
              <div class="matched-user-avatar-wrapper">
                <img
                  :src="aiMatchData.recommendedUser.avatar || '/default-avatar.png'"
                  class="matched-user-avatar"
                  alt="用户头像"
                >
                <div class="matched-user-online"></div>
              </div>
              <div class="matched-user-info">
                <h4 class="matched-user-name">{{ aiMatchData.recommendedUser.nickname }}</h4>
                <div class="matched-user-tags">
                  <span class="matched-tag">{{ aiMatchData.recommendedUser.gender === 1 ? '男' : '女' }}</span>
                  <span class="matched-tag">{{ aiMatchData.recommendedUser.age }}岁</span>
                  <span class="matched-tag">{{ aiMatchData.recommendedUser.city || '未知' }}</span>
                </div>
                <div class="matched-user-detail">
                  <button class="view-profile-btn" @click="showUserProfile(aiMatchData.recommendedUser.userId)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.58-7 8-7s8 3 8 7"/></svg>
                    查看完整资料
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- AI匹配理由 -->
        <div class="result-section">
          <div class="section-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a10 10 0 0110 10c0 5-4 8-10 8-1.5 0-3-.3-4.3-.9L4 21l1.5-4.2A9.9 9.9 0 012 12 10 10 0 0112 2z"/></svg>
            AI匹配理由
          </div>
          <div class="match-reason-card">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF7E7E" stroke-width="2"><path d="M12 2a10 10 0 0110 10c0 5-4 8-10 8-1.5 0-3-.3-4.3-.9L4 21l1.5-4.2A9.9 9.9 0 012 12 10 10 0 0112 2z"/></svg>
            <p>{{ aiMatchData.matchReasonDetail }}</p>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="result-actions">
          <button
            class="action-btn-primary"
            @click="startChat(aiMatchData.recommendedUser.userId)"
            :disabled="isProcessing || loading"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            与{{ aiMatchData.recommendedUser.nickname }}开始聊天
          </button>
          <button
            class="action-btn-secondary"
            @click="matchUser(aiMatchData.recommendedUser.userId)"
            :disabled="isProcessing || loading"
          >
            <span v-if="!isProcessing">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
              发起匹配请求
            </span>
            <span v-else>
              <div class="spinner-sm"></div>
              处理中...
            </span>
          </button>
          <button
            class="action-btn-ghost"
            @click="fetchAiRecommend"
            :disabled="loading || isProcessing"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
            重新推荐
          </button>
        </div>
      </div>

      <!-- ===== AI聊天内容分析 ===== -->
      <div v-if="!loading" class="result-container" style="margin-top:20px">
        <div class="result-header">
          <div class="result-header-left">
            <div class="result-header-icon" style="background:linear-gradient(135deg,rgba(46,204,113,0.12),rgba(46,204,113,0.06));color:#2ecc71">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            </div>
            <div>
              <div class="result-header-title">AI聊天内容分析</div>
              <div class="result-header-desc">根据你与好友之间的聊天内容，分析交友过程中存在的问题，并给出改正意见</div>
            </div>
          </div>
          <button class="action-btn-ghost" @click="openChatAnalysis" :disabled="chatAnalyzing">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            {{ chatAnalyzing ? '分析中...' : '开始分析' }}
          </button>
        </div>
        <div v-if="chatAnalysisResult" class="rc-body" style="padding:0 0 4px">
          <div class="analysis-card" style="margin:0">
            <div class="analysis-header"><span class="analysis-badge them-badge">分析</span><h4>聊天分析结果</h4></div>
            <p class="analysis-text" style="white-space:pre-wrap">{{ chatAnalysisResult }}</p>
          </div>
        </div>
        <div v-else-if="!chatAnalyzing" style="padding:12px 0;text-align:center;color:var(--app-text-muted);font-size:0.8125rem">
          选择一位好友，AI将分析你们的聊天内容
        </div>
      </div>

      <!-- 选择好友对话框 -->
      <el-dialog v-model="friendDialogVisible" title="选择好友" width="500px" class="gift-dialog" :close-on-click-modal="true">
        <div v-if="friendsList.length === 0">
          <el-empty description="暂无好友"></el-empty>
        </div>
        <div v-else class="friend-list">
          <div v-for="f in friendsList" :key="f.friendId" class="friend-item" :class="{selected: selectedFriendId === f.friendId}" @click="selectedFriendId = f.friendId">
            <img :src="f.avatar || defaultAvatar" class="friend-avatar" alt="">
            <div class="friend-info">
              <span class="friend-name">{{ f.nickname }}</span>
              <span class="friend-status" v-if="f.online">在线</span>
              <span class="friend-status offline" v-else>离线</span>
            </div>
          </div>
        </div>
        <template #footer>
          <el-button @click="friendDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="startChatAnalysis" :disabled="!selectedFriendId || chatAnalyzing">开始分析</el-button>
        </template>
      </el-dialog>

      <!-- 空状态 -->
      <div v-if="!loading && !errorMsg && !aiMatchData" class="result-container empty-card">
        <div class="result-header">
          <div class="result-header-left">
            <div class="result-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a4 4 0 014 4c0 2-1 3-2 4l-2 8-2-8c-1-1-2-2-2-4a4 4 0 014-4z"/><path d="M8 9h8"/><path d="M9 13h6"/></svg>
            </div>
            <div>
              <div class="result-header-title">AI好友推荐</div>
              <div class="result-header-desc">根据个人资料的生日获取八字与星座最匹配的好友</div>
            </div>
          </div>
        </div>
        <div class="empty-state-container">
        <div class="empty-graphic">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#B2BEC3" stroke-width="1"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
          <div class="empty-heart">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#FF7E7E" stroke="none"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
          </div>
        </div>
        <p class="empty-title">尚未进行AI匹配分析</p>
        <p class="empty-desc">点击下方按钮，让AI为你寻找灵魂伴侣</p>
        <button
          @click="fetchAiRecommend"
          class="action-btn-primary start-btn"
          :disabled="loading || isProcessing"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <span v-if="!loading">开始匹配</span>
          <span v-else>
            <div class="spinner-sm"></div>
            处理中...
          </span>
        </button>
      </div>
      <!-- 用户资料卡片 -->
      <UserProfileCard
        :visible="profileCardVisible"
        :profile="targetProfile"
        @close="profileCardVisible = false"
      />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { ElMessage, ElDrawer } from 'element-plus';
import UserProfileCard from '@/views/match/UserProfileCard.vue';
import userProfileApi from '@/api/userProfile';

import matchApi from '@/api/match';
import friendApi from '@/api/friend';

// 路由实例
const router = useRouter();

// 状态管理
const loading = ref(false);         // AI匹配分析加载状态
const isProcessing = ref(false);    // 匹配请求处理中状态
const errorMsg = ref('');
const aiMatchData = ref(null);
const currentUserId = ref(localStorage.getItem('userId') ? Number(localStorage.getItem('userId')) : null);
const currentStep = ref(1);         // AI匹配当前步骤
const matchingSubMessage = ref('正在获取您的个人命理信息...');
let stepInterval = null;            // 步骤更新定时器

// AI聊天内容分析
const chatAnalyzing = ref(false);
const chatAnalysisResult = ref('');
const friendDialogVisible = ref(false);
const friendsList = ref([]);
const selectedFriendId = ref(null);
const defaultAvatar = 'https://picsum.photos/id/1005/200';

const openChatAnalysis = async () => {
  selectedFriendId.value = null;
  chatAnalysisResult.value = '';
  try {
    const res = await friendApi.getFriendList(currentUserId.value);
    if (res.data?.code === 200 || res.data?.code === '200') {
      friendsList.value = res.data.data || [];
    } else {
      friendsList.value = [];
    }
  } catch (e) {
    console.error('获取好友列表失败:', e);
    friendsList.value = [];
  }
  friendDialogVisible.value = true;
};

const startChatAnalysis = async () => {
  if (!selectedFriendId.value || !currentUserId.value) return;
  friendDialogVisible.value = false;
  chatAnalyzing.value = true;
  chatAnalysisResult.value = '';
  try {
    const res = await axios.get('/deepseek/api/deepseek/chat-analysis', {
      params: { userId: currentUserId.value, targetUserId: selectedFriendId.value },
      timeout: 60000
    });
    if (res.data && (res.data.code === '200' || res.data.code === 200) && res.data.data) {
      chatAnalysisResult.value = res.data.data;
    } else {
      ElMessage.error(res.data?.msg || '分析失败');
    }
  } catch (err) {
    console.error('聊天分析失败:', err);
    ElMessage.error(err.message?.includes('timeout') ? '分析超时，请稍后重试' : '分析失败');
  } finally {
    chatAnalyzing.value = false;
  }
};

// 用户资料卡片
const profileCardVisible = ref(false);
const targetProfile = ref(null);
const showUserProfile = async (userId) => {
  profileCardVisible.value = true;
  targetProfile.value = null;
  try {
    const basicInfo = {
      nickname: aiMatchData.value?.recommendedUser?.nickname || '',
      avatar: aiMatchData.value?.recommendedUser?.avatar || '',
      userId
    };
    const res = await userProfileApi.getByUserId(userId);
    if (res.data && (res.data.code === '200' || res.data.code === 200) && res.data.data) {
      targetProfile.value = { ...basicInfo, ...res.data.data };
    } else {
      targetProfile.value = basicInfo;
    }
  } catch (err) {
    console.error('获取用户资料失败:', err);
    targetProfile.value = basicInfo;
  }
};

// 格式化农历生日
const formatLunarBirthday = (birthdayString) => {
  if (!birthdayString) return '未设置';
  const date = new Date(birthdayString);
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// 根据匹配度获取对应的颜色类名
const getScoreColorClass = (score) => {
  if (score >= 80) return 'high';
  if (score >= 60) return 'medium';
  return 'low';
};

// 更新匹配步骤和提示信息
const updateMatchingStep = () => {
  if (currentStep.value == 1) {
    currentStep.value = 2;
    matchingSubMessage.value = '正在分析星座匹配度和命理相容性...';
  } else if (currentStep.value == 2) {
    currentStep.value = 3;
    matchingSubMessage.value = '正在从数据库中筛选最佳匹配对象...';
  } else {
    matchingSubMessage.value = '正在生成详细匹配报告...';
  }
};

// 获取AI推荐匹配数据
const fetchAiRecommend = async () => {
  if (!currentUserId.value) {
    ElMessage.warning('请先登录后再进行匹配');
    router.push('/login');
    return;
  }

  if (loading.value || isProcessing.value) return;

  // 重置状态并显示加载
  loading.value = true;
  errorMsg.value = '';
  aiMatchData.value = null;
  currentStep.value = 1;
  matchingSubMessage.value = '正在获取您的个人命理信息...';

  // 启动步骤更新定时器
  stepInterval = setInterval(updateMatchingStep, 3000);

  try {
    const res = await axios.get('/deepseek/api/deepseek/ai-recommend', {
      params: { userId: currentUserId.value },
      timeout: 3000000
    });

    if (res.data.code == '200' && res.data.success) {
      aiMatchData.value = res.data.data;
    } else {
      errorMsg.value = res.data.msg || '获取AI推荐失败';
      ElMessage.error(errorMsg.value);
    }
  } catch (error) {
    console.error('获取AI推荐失败:', error);
    errorMsg.value = error.message.includes('timeout')
      ? 'AI分析超时，请稍后重试'
      : '网络异常，请稍后重试';
    ElMessage.error(errorMsg.value);
  } finally {
    clearInterval(stepInterval);
    stepInterval = null;
    loading.value = false;
  }
};

// 发起匹配（完全移除ElLoading）
const matchUser = async (targetUserId) => {
  if (!targetUserId) {
    ElMessage.warning('用户信息异常');
    return;
  }
  if (!currentUserId.value) {
    ElMessage.warning('请先登录');
    router.push('/login');
    return;
  }
  if (isProcessing.value || loading.value) return;

  // 仅使用基础状态控制
  isProcessing.value = true;

  try {
    const res = await matchApi.likeUser({
      userId: currentUserId.value,
      targetUserId: targetUserId
    }, {
      timeout: 15000
    });

    if (res.data.success) {
      ElMessage.success('已向该用户发起匹配请求，等待对方回应');
    } else {
      ElMessage.error(res.data.msg || '发起匹配失败');
    }
  } catch (error) {
    console.error('发起匹配失败:', error);
    ElMessage.error('操作失败，请稍后重试');
  } finally {
    // 确保状态重置
    setTimeout(() => {
      isProcessing.value = false;
    }, 300); // 延迟一点关闭，让用户看到反馈
  }
};

// 开始聊天
const startChat = (targetUserId) => {
  if (!targetUserId) {
    ElMessage.warning('用户信息异常');
    return;
  }

  router.push({
    path: '/',
    query: { targetUserId }
  });
};


// 页面卸载时清除定时器
onUnmounted(() => {
  if (stepInterval) {
    clearInterval(stepInterval);
  }
});

onMounted(() => {
  // 页面加载时不自动调用接口
});
</script>

<style scoped>
.ai-recommend-page {
  min-height: 100%;
}

.ai-content {
  margin-top: 16px;
}

/* ── 加载状态 ── */
.fullpage-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.loading-wrapper {
  text-align: center;
}

.loading-heart {
  animation: heartbeat 1.2s ease-in-out infinite;
  color: var(--app-color-primary);
  margin-bottom: 20px;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  15% { transform: scale(1.2); }
  30% { transform: scale(1); }
  45% { transform: scale(1.1); }
  60% { transform: scale(1); }
}

.loading-text {
  font-size: 1rem;
  color: var(--app-text-secondary);
  margin: 0;
}

/* ── 处理中弹窗 ── */
.processing-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(4px);
}

.modal-content {
  position: relative;
  background: var(--app-bg-elevated);
  padding: 32px 40px;
  border-radius: var(--app-radius-xl);
  text-align: center;
  box-shadow: var(--app-shadow-elevated);
  min-width: 240px;
}

.processing-heart {
  animation: heartbeat 1.2s ease-in-out infinite;
  color: var(--app-color-primary);
  margin-bottom: 16px;
}

.processing-text {
  font-size: 1rem;
  color: var(--app-text-primary);
  margin: 0;
}

/* ── 匹配进度 ── */
.matching-progress {
  padding: 16px 0;
}

.progress-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.step-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--app-bg-soft);
  color: var(--app-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
  border: 2px solid transparent;
}

.step.active .step-icon {
  background: var(--app-gradient-primary);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(255, 126, 126, 0.3);
}

.step-text {
  font-size: 0.8125rem;
  color: var(--app-text-muted);
  transition: all 0.3s;
  white-space: nowrap;
}

.step.active .step-text {
  color: var(--app-color-primary);
  font-weight: 600;
}

.step-separator {
  width: 60px;
  height: 3px;
  background: var(--app-border-light);
  margin: 0 12px;
  margin-bottom: 28px;
  border-radius: 2px;
  transition: all 0.4s;
}

.step-separator.active {
  background: var(--app-gradient-primary);
}

.matching-message {
  text-align: center;
}

.main-message {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 8px;
}

.sub-message {
  font-size: 0.875rem;
  color: var(--app-text-secondary);
  margin: 0;
}

/* ── 错误消息 ── */
.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: #FFF5F5;
  border: 1px solid rgba(231, 76, 60, 0.15);
  border-radius: var(--app-radius-md);
  color: #e74c3c;
  font-size: 0.875rem;
}

.retry-btn {
  margin-left: auto;
  padding: 6px 16px;
  border-radius: var(--app-radius-full);
  border: 1px solid #e74c3c;
  background: transparent;
  color: #e74c3c;
  cursor: pointer;
  font-size: 0.8125rem;
  transition: all 0.2s;
}

.retry-btn:hover {
  background: #e74c3c;
  color: white;
}

/* ── 结果容器 ── */
.result-container {
  background: var(--app-bg-elevated);
  border-radius: var(--app-radius-lg);
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
  padding: 28px;
  overflow: hidden;
}

.result-section {
  margin-bottom: 28px;
}

.result-section:last-child {
  margin-bottom: 0;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--app-border-light);
}

/* ── 匹配度展示 ── */
.score-section {
  text-align: center;
}

.score-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.score-ring {
  color: var(--app-color-primary);
}

.score-arc {
  transition: stroke-dashoffset 1.5s ease;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--app-border-light);
}
.result-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.result-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(108,92,231,0.12), rgba(162,155,254,0.12));
  color: #6C5CE7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.result-header-title {
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--app-text-primary);
}
.result-header-desc {
  font-size: 0.8125rem;
  color: var(--app-text-muted);
  margin-top: 2px;
}

.score-number {
  fill: var(--app-text-primary);
}

.score-label-text {
  fill: var(--app-text-muted);
}

.score-level {
  font-size: 1.125rem;
  font-weight: 600;
  padding: 6px 20px;
  border-radius: var(--app-radius-full);
}

.score-level.high {
  background: rgba(46, 204, 113, 0.1);
  color: #2ecc71;
}

.score-level.medium {
  background: rgba(255, 193, 7, 0.1);
  color: #f39c12;
}

.score-level.low {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}

/* ── 命理分析 ── */
.analysis-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.analysis-card {
  padding: 20px;
  border-radius: var(--app-radius-md);
  border: 1px solid var(--app-border-light);
  background: var(--app-bg-soft);
}

.analysis-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.analysis-header h4 {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0;
}

.analysis-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.you-badge {
  background: var(--app-gradient-primary);
}

.them-badge {
  background: var(--app-gradient-secondary);
}

.analysis-text {
  font-size: 0.875rem;
  color: var(--app-text-secondary);
  line-height: 1.7;
  margin: 0 0 12px;
}

.constellation-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8125rem;
  color: #8B7CF7;
  margin: 0;
  font-style: italic;
}

/* ── 匹配用户卡片 ── */
.matched-user-card {
  border-radius: var(--app-radius-md);
  border: 1px solid var(--app-border-light);
  overflow: hidden;
  position: relative;
}

.matched-user-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: var(--app-gradient-primary);
  opacity: 0.06;
}

.matched-user-content {
  display: flex;
  gap: 20px;
  padding: 24px;
  position: relative;
}

.matched-user-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
}

.matched-user-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--app-bg-elevated);
  box-shadow: 0 4px 12px rgba(255, 126, 126, 0.2);
}

.matched-user-online {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #2ecc71;
  border: 3px solid var(--app-bg-elevated);
}

.matched-user-info {
  flex: 1;
}

.view-profile-btn {
  display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px;
  border-radius: 20px; border: 1px solid var(--app-color-primary);
  color: var(--app-color-primary); background: transparent;
  font-size: 0.8125rem; cursor: pointer; transition: all 0.2s; margin-top: 4px;
}
.view-profile-btn:hover {
  background: var(--app-color-primary); color: white;
}

.matched-user-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--app-text-primary);
  margin: 0 0 8px;
}

.matched-user-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.matched-tag {
  padding: 3px 10px;
  border-radius: var(--app-radius-full);
  font-size: 0.75rem;
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary-dark);
  font-weight: 500;
}

.matched-user-detail {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.detail-label {
  font-size: 0.8125rem;
  color: var(--app-text-muted);
  min-width: 64px;
  flex-shrink: 0;
}

.detail-value {
  font-size: 0.8125rem;
  color: var(--app-text-secondary);
}

.tags-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.tag-pill {
  padding: 2px 8px;
  border-radius: var(--app-radius-full);
  font-size: 0.6875rem;
  background: var(--app-bg-soft);
  color: var(--app-text-secondary);
  border: 1px solid var(--app-border-light);
}

/* ── AI匹配理由 ── */
.match-reason-card {
  display: flex;
  gap: 12px;
  padding: 20px;
  background: var(--app-color-primary-muted);
  border-radius: var(--app-radius-md);
  border: 1px solid rgba(255, 126, 126, 0.1);
}

.match-reason-card svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.match-reason-card p {
  font-size: 0.875rem;
  color: var(--app-text-secondary);
  line-height: 1.7;
  margin: 0;
}

/* ── 操作按钮 ── */
.result-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--app-border-light);
}

.action-btn-primary,
.action-btn-secondary,
.action-btn-ghost {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: var(--app-radius-full);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s;
  font-family: inherit;
  border: none;
  white-space: nowrap;
}

.action-btn-primary {
  background: var(--app-gradient-primary);
  color: white;
  box-shadow: 0 4px 14px rgba(255, 126, 126, 0.25);
}

.action-btn-primary:hover {
  box-shadow: 0 6px 20px rgba(255, 126, 126, 0.4);
  transform: translateY(-1px);
}

.action-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.action-btn-secondary {
  background: var(--app-bg-elevated);
  color: var(--app-color-primary);
  border: 2px solid var(--app-color-primary-soft);
}

.action-btn-secondary:hover {
  background: var(--app-color-primary-soft);
  border-color: var(--app-color-primary);
}

.action-btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-btn-ghost {
  background: transparent;
  color: var(--app-text-secondary);
  border: 1px solid var(--app-border-light);
}

.action-btn-ghost:hover {
  border-color: var(--app-text-muted);
  background: var(--app-bg-soft);
}

.action-btn-ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.spinner-sm {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── 空状态 ── */
.empty-state-container {
  background: var(--app-bg-elevated);
  border-radius: var(--app-radius-lg);
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
  padding: 60px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.empty-graphic {
  position: relative;
  margin-bottom: 20px;
}

.empty-heart {
  position: absolute;
  bottom: 0;
  right: -8px;
  animation: heartbeat 1.5s ease-in-out infinite;
}

.empty-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 8px;
}

.empty-desc {
  font-size: 0.875rem;
  color: var(--app-text-muted);
  margin: 0 0 28px;
}

.start-btn {
  padding: 14px 36px;
  font-size: 1rem;
}

/* ── 响应式 ── */
@media (max-width: 768px) {
  .result-container {
    padding: 16px;
  }

  .analysis-grid {
    grid-template-columns: 1fr;
  }

  .matched-user-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .matched-user-tags {
    justify-content: center;
  }

  .detail-row {
    justify-content: center;
  }

  .result-actions {
    flex-direction: column;
  }

  .action-btn-primary,
  .action-btn-secondary,
  .action-btn-ghost {
    width: 100%;
  }

  .progress-steps {
    flex-direction: column;
  }

  .step {
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
  }

  .step-icon {
    margin-right: 12px;
    margin-bottom: 0;
  }

  .step-separator {
    width: 3px;
    height: 24px;
    margin: 6px 0 6px 24px;
  }
}

.friend-list {
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.friend-list::-webkit-scrollbar {
  width: 4px;
}

.friend-list::-webkit-scrollbar-thumb {
  background: var(--app-border-light);
  border-radius: 2px;
}

.friend-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: var(--app-radius-md);
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.friend-item:hover {
  background: var(--app-color-primary-muted);
  border-color: var(--app-border-light);
}

.friend-item.selected {
  background: var(--app-color-primary-soft);
  border-color: var(--app-color-primary-light);
}

.friend-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.friend-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.friend-name {
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--app-text-primary);
}

.friend-status {
  font-size: 0.75rem;
  color: #2ecc71;
}

.friend-status.offline {
  color: var(--app-text-muted);
}

@media (max-width: 992px) {
  .analysis-grid {
    grid-template-columns: 1fr;
  }
}
</style>